import React from 'react';
import { ToastOptions, toast } from 'react-toastify';

import ToastComponent from 'components/ToastV2';
import { ToastVariant } from 'const';

interface ToasterCreatorProps {
  message: string;
  title?: string;
  link?: string;
  linkText?: string;
  options?: ToastOptions;
  type: ToastVariant;
}

const toasterCreator = ({
  message,
  title,
  link,
  linkText,
  options,
  type,
}: ToasterCreatorProps): (() => void) => {
  const defaultOptions: ToastOptions = {
    autoClose: false,
    position: toast.POSITION.TOP_RIGHT,
    draggable: false,
    hideProgressBar: true,
    closeOnClick: false,
    closeButton: false,
  };

  const mergedOptions = {
    ...defaultOptions,
    ...options,
  };

  const toastId = toast(
    ({ closeToast }) => (
      <ToastComponent closeToast={closeToast} title={title} message={message} link={link} type={type} linkText={linkText}/>
    ),
    mergedOptions,
  );

  return () => toast.dismiss(toastId);
};

type ToastParams = {
  message: string;
  title?: string;
  link?: string;
  linkText?: string;
  options?: ToastOptions;
};

export function successV2({ message, title, link, linkText, options }: ToastParams): () => void {
  return toasterCreator({ message, title, link, linkText, options, type: ToastVariant.SUCCESS });
}

export function errorV2({ message, title, link, linkText, options }: ToastParams): () => void {
  return toasterCreator({ message, title, link, linkText, options, type: ToastVariant.ERROR });
}

export function warningV2({ message, title, link, linkText, options }: ToastParams): () => void {
  return toasterCreator({ message, title, link, options, linkText, type: ToastVariant.WARNING });
}

export function loadingV2({ message, title, link, linkText, options }: ToastParams): () => void {
  return toasterCreator({ message, title, link, options, linkText, type: ToastVariant.LOADING });
}
